var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-post-poll-types grid-2"},_vm._l((_vm.pollTypes),function(pollType){return _c('a',{key:pollType.key,staticClass:"poll-type grid-item",on:{"click":function($event){return _vm.selectPollType(pollType)}}},[_c('span',[_vm._v(_vm._s(pollType.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }